import { useParams } from 'react-router-dom';

import { OnboardingPage } from '~/components/pages/OnboardingPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppOnboardingRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <OnboardingPage appId={appId} />
    </DashboardTemplate>
  );
};
